import {
  confirmDialog,
  CustomButton,
  CustomCheckbox,
  CustomCollapseCard,
  CustomImage,
  CustomInput,
  CustomMaskInput,
  CustomMoneyInput,
  CustomPagination,
  CustomTable,
  EditableCell,
  errorDialog,
  successDialog,
  Text,
  warningDialog,
  useText,
} from '@src/components';
import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import '@src/styles/cardOrder/cardDetailInformationCompliment.scss';
import { Button, Form, Tooltip, Menu } from 'antd';
import downloadIcon from '@src/assets/icons/icon-download.svg';
import excelIcon from '@src/assets/icons/icon-excel.svg';
import uploadIcon from '@src/assets/icons/icon-upload.svg';
import cardIcon from '@src/assets/icons/icon-kart.svg';
import plusIcon from '@src/assets/icons/add.svg';
import addPassive from '@src/assets/icons/add_passive.svg';
import { formMailRegex, formPhoneRegex } from '@src/utils/formRule';
import { useDispatch, useSelector } from 'react-redux';
import {
  cardOrdersDelete,
  cardOrdersSave,
  getCurrentCardOrder,
  setCurrentCardOrder,
} from '@src/store/slice/cardOrderSlice';
import {
  cardOrderDetailDelete,
  cardOrderDetailSave,
  cardOrderDetailsGelAll,
  cardOrderDetailUpdate,
  resetDetail,
  setCardList,
  setSelectedExistUsersRow,
  setSelectedRow,
} from '@src/store/slice/cardOrderDetailtsSlice';
import cardOrderDetailsServices from '@src/services/cardOrderDetails.services';
import { getFileNameByLanguage, isGreaterMaximumLoadedAmount, moneyFormat } from '@src/utils/utils';
import trash from '@src/assets/icons/trash_red.svg';
import edit from '@src/assets/icons/edit_gray.svg';
import compTick from '@src/assets/icons/comp-tick.svg';
import compMinus from '@src/assets/icons/comp-minus.svg';
import download from 'js-file-download';
import dayjs from '@src/utils/day';
import iconInfo from '@src/assets/icons/icon-bilgi.svg';
import { addressGetPagedListByUserQuery } from '@src/store/slice/addressSlice';
import { setLoadingState } from '@src/store/slice/appSettingsSlice';
import { getCurrentEmployeeList } from '@src/store/slice/balanceUploadDetailSlice';
import { getCurrentLoadBalance } from '@src/store/slice/balanceUploadSlice';
import DeliveryAddressAddForm from '@src/pages/ticketRestaurant/cardOrders/cardInformation/DeliveryAddressAddForm';
import DeliveryAddressChooseForm from '@src/pages/ticketRestaurant/cardOrders/cardInformation/DeliveryAddressChooseForm';
import UploadFileModal from '@src/pages/ticketRestaurant/cardOrders/cardInformation/UploadFileModal';
import PropTypes from 'prop-types';
import { VouIdCode } from '@src/store/enums';

function getInput(openModalWarning) {
  return (props) => (
    <CustomInput
      {...props}
      id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput-input"
      numeric="numeric"
      placeholder={useText('name')}
      height={36}
      maxLength={50}
      onBlur={() => openModalWarning()}
    />
  );
}

function getInput1() {
  return (props) => (
    <CustomInput
      id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput1-input"
      numeric="numeric"
      maxLength={50}
      upperCase="upperCase"
      {...props}
      placeholder={useText('surname')}
      height={36}
    />
  );
}

function getInput2(checkIsMobile, showError = false) {
  return (props) => (
    <>
      <CustomMaskInput
        id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput2-maskInput"
        onChange={() => checkIsMobile()}
        onBlur={() => checkIsMobile()}
        {...props}
        mask={'+\\90 (999) 999 99 99'}
      >
        <CustomInput
          id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput2-input"
          placeholder={'+90 (___) ___ __ __'}
          height={36}
        />
      </CustomMaskInput>
      {showError && (
        <span className="common-contact-warning">
          <Text t="thisFieldCannotBeLeftBlank" />
        </span>
      )}
    </>
  );
}

function getInput4(changeAmount = null, amount3) {
  return (props) => {
    if (changeAmount)
      return (
        <CustomMoneyInput
          onBlur={() => changeAmount()}
          id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput4-moneyInput"
          {...props}
          placeholder={amount3}
          height={36}
        />
      );
    return (
      <CustomMoneyInput
        id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput4-moneyInput"
        {...props}
        placeholder={amount3}
        height={36}
      />
    );
  };
}

function getInput5() {
  return (props) => (
    <CustomInput
      id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput5-input"
      {...props}
      placeholder={useText('referenceNo')}
      height={36}
      maxLength={20}
    />
  );
}

function getInput7() {
  return (props) => (
    <CustomInput
      {...props}
      id="ticketCompliments-cardOrders-cardInformation-cardDetailInformation-email-input"
      type="email"
      placeholder={useText('emailUpperCase')}
      height={36}
      maxLength={100}
    />
  );
}

function getInput6(editableAddressRender, record) {
  return (props) => {
    return (
      <>
        {editableAddressRender(record?.addressText, record)}
        <CustomInput
          {...props}
          id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-getInput6-input"
          value={record.addressId}
          disabled
          style={{ display: 'none' }}
          height={36}
        />
      </>
    );
  };
}

const CardDetailInformation = ({
  form,
  resetCard,
  vouId = VouIdCode.Compliments,
  uploadModalProps = { isCompliments: true },
  showExistingUsersPickerButton = true,
  enableDigitalContactInfo = true,
}) => {
  const history = useHistory();
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);
  const { cardList, tableProperty, selectedRow, selectedExistUsersRow, allCardAddressCheckedData } =
    useSelector((state) => state?.cardOrderDetails);
  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { maximumLoadedAmount } = useSelector((state) => state?.orderLimits);
  const { addressListByUserQuery } = useSelector((state) => state?.address);

  const dispatch = useDispatch();
  const [isModalDeliveryAddressChoose, setIsModalDeliveryAddressChoose] = useState(false);
  const [isModalDeliveryAddressAdd, setIsModalDeliveryAddressAdd] = useState(false);
  const [editingKey, setEditingKey] = useState('');
  const [uploadModalVisible, setUploadModalVisible] = useState(false);
  const [modalVisibled, setModalVisibled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const isEditing = (record) => record.id === editingKey;
  const [gsmRequired, setGsmRequired] = useState(false);
  const [existUserAllPrice, setExistUserAllPrice] = useState('');
  const [addedFromExistList, setAddedFromExistList] = useState([]);
  const [allPageAmountChange, setAllPageAmountChange] = useState(false);
  const [showExistUserButton, setShowExistUserButton] = useState(false);
  const [flagExistUsers, setFlagExistUsers] = useState(false);
  const [isCheckedMobile, setIsCheckedMobile] = useState(false);
  const [showNewCardButtons, setShowNewCardButtons] = useState(false);
  const [uploadedExcel, setUploadedExcel] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [requiredName, setRequiredName] = useState(false);
  const [requiredColumn, setRequiredColumn] = useState(false);
  const [showPageCount, setShowPageCount] = useState(100);
  const [currentCardOrderCardTypeDigital, setCurrentCardOrderCardTypeDigital] = useState(false);
  const [mobilePaymentAuthorization, setMobilePaymentAuthorization] = useState(false);
  const [editingRowKeys, setEditingRowKeys] = useState([]);
  const [showError, setShowError] = useState(false);
  const { customerVou } = useSelector((state) => state?.customer);
  const { currentLoadBalance } = useSelector((state) => state?.balanceUpload);
  const { allCurrentEmployeeList, tablePropertyEmployeeList } = useSelector(
    (state) => state?.balanceUploadDetail,
  );
  const yourTransactionHasBeenSuccessfullyCompleted = useText('yourTransactionHasBeenSuccessfullyCompleted');
  const maximumLoadingLimitPerCardIs = useText('maximumLoadingLimitPerCardIs');
  const cardInformation2 = useText('cardInformation2');
  const currentEmployeeList = useText('currentEmployeeList');
  const recordAddedSuccessfully = useText('recordAddedSuccessfully');
  const nameUpperCase = useText('nameUpper');
  const surnameUpperCase = useText('surnameUpperCase');
  const gsmNoUpperCase = useText('gsmNoUpperCase');
  const emailUpperCase = useText('emailUpperCase');
  const digitalCardContactInfoRequired = useText('digitalCardContactInfoRequired');
  const amount3 = useText('amount3');

  const fillCardListFromExistUsers = async () => {
    await dispatch(setLoadingState(true));
    let fieldsValues = await form.getFieldsValue();
    const newCardList = allCurrentEmployeeList?.map((item) => {
      let newItem = { ...item };
      newItem.addressText = item.addressName;
      newItem.price = item.price ?? allPageAmountChange ? existUserAllPrice : 0;
      try {
        if (selectedExistUsersRow?.length > 0) {
          const flagItem = cardList?.filter((cItem) => cItem.refNo === item.refNo);
          if (flagItem?.length > 0 && flagItem[0]?.price) {
            newItem.price = flagItem[0].price;
            newItem.gsm = flagItem[0].gsm;
            newItem.email = flagItem[0].email;
            newItem.mobilePaymentAuthorization = flagItem[0].mobilePaymentAuthorization;
            fieldsValues['price-' + newItem.refNo] = flagItem[0].price;
            fieldsValues['gsm-' + newItem.refNo] = newItem.gsm;
            fieldsValues['email-' + newItem.refNo] = newItem.email;
            fieldsValues['mobilePaymentAuthorization-' + newItem.refNo] =
              flagItem[0].mobilePaymentAuthorization;
          }
        }
      } catch (error) {
        console.error(error);
      }
      return newItem;
    });
    await dispatch(setCardList([...newCardList]));
    if (selectedExistUsersRow?.length > 0) {
      await form.setFieldsValue({
        ...fieldsValues,
      });
      setSelectedItems(selectedExistUsersRow);
    }
    await dispatch(setLoadingState(false));
  };

  useEffect(() => {
    if (flagExistUsers) {
      fillCardListFromExistUsers();
    }
  }, [allCurrentEmployeeList, flagExistUsers]);

  useEffect(() => {
    if (!selectedExistUsersRow?.length > 0) {
      setSelectedItems([]);
    }
  }, [selectedExistUsersRow]);

  useEffect(() => {
    if (!flagExistUsers && selectedExistUsersRow?.length > 0 && currentCardOrder.totalCount > 0) {
      setFlagExistUsers(true);
    }
    if (currentCardOrder.totalCount === 0 && addedFromExistList?.length > 0) {
      setAddedFromExistList([]);
    }
  }, [allCurrentEmployeeList, selectedExistUsersRow, currentCardOrder, flagExistUsers]);

  useEffect(async () => {
    if (uploadedExcel) await dispatch(cardOrderDetailsGelAll({ pageNumber: 1, pageSize: 100 }));
  }, [uploadedExcel]);

  useEffect(() => {
    if (customerVou && allCurrentEmployeeList?.length) {
      setShowExistUserButton(true);
    }
  }, [customerVou, allCurrentEmployeeList]);

  useEffect(() => {
    setRequiredName(currentCardOrder?.cardType === 0 && currentCardOrder?.printNameSurname);
  }, [currentCardOrder]);

  useEffect(() => {
    setRequiredColumn(
      currentCardOrder?.cardType === 2 ||
      currentCardOrder?.cardType === 1 ||
      (currentCardOrder?.cardType === 0 && gsmRequired),
    );
  }, [currentCardOrder?.cardType, gsmRequired]);

  useLayoutEffect(() => {
    if (
      (!flagExistUsers && cardList.length === 0) ||
      (!flagExistUsers && cardList?.filter((item) => !item.id).length === 0)
    ) {
      handleAdd(cardList?.filter((item) => !item.id).length === 0);
    } else if (flagExistUsers && cardList.length === 0 && allCurrentEmployeeList?.length > 0) {
      fillCardListFromExistUsers();
    }
  }, [cardList]);

  useEffect(() => {
    if (allCurrentEmployeeList?.length === 0 && currentLoadBalance) {
      callGetCurrentEmployeeList();
    }
  }, [currentLoadBalance, vouId]);

  useEffect(() => {
    if (currentLoadBalance) {
      callGetCurrentEmployeeList();
    }
  }, [currentLoadBalance, showPageCount, vouId]);

  const callGetCurrentEmployeeList = async () => {
    await dispatch(setLoadingState(true));
    await dispatch(
      getCurrentEmployeeList({
        loadBalanceId: currentLoadBalance?.id,
        showOnlyPriced: false,
        vouId,
        pageSize: 100000,
      }),
    );
    await dispatch(setLoadingState(false));
  };

  const runChangeType2 = async () => {
    if (flagExistUsers) {
      setFlagExistUsers(false);
      await dispatch(setSelectedExistUsersRow([]));
      await dispatch(setCardList([]));
    } else if (uploadedExcel) {
      setUploadedExcel(false);
      await dispatch(setCardList([]));
    } else {
      const checkRecordId = cardList?.filter((recordItem) => recordItem?.id === undefined);
      if (checkRecordId.length > 0) {
        handleSave();
        dispatch(setCardList([...cardList]));
      } else if (allCardAddressCheckedData?.addressId) {
        dispatch(setCardList([...cardList, { ...allCardAddressCheckedData }]));
        form.resetFields();
        form.setFieldsValue({
          ...allCardAddressCheckedData,
        });
      } else {
        setShowNewCardButtons(true);
        dispatch(setCardList([...cardList, {}]));
        form.resetFields();
      }
      setEditingKey(undefined);
    }
  };
  const clickChangeType = async (stateChangeType, callReset = true) => {
    if (stateChangeType === 1) {
      setFlagExistUsers(true);
      await dispatch(setLoadingState(true));
      await dispatch(getCurrentLoadBalance({ vouId }));
      await dispatch(setLoadingState(false));
    } else if (stateChangeType === 2) {
      runChangeType2();
    }
    if (callReset) resetCard();
  };

  const showWarningDialog = (stateChangeType) => {
    if (!currentCardOrder?.id) {
      clickChangeType(stateChangeType, false);
      return;
    }
    warningDialog({
      title: <Text t="attention" />,
      htmlContent: (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <p className="gift-cancel-order-text">
            <Text t="whenYouLeaveThisPageTheInformationYou4" />
          </p>{' '}
          <p className="gift-cancel-order-text">
            <Text t="areYouSureYouWantToContinue" />
          </p>
          <button
            className="utts-ok-button gift-cancel-order-confirm"
            onClick={() => clickChangeType(stateChangeType)}
          >
            <Text t="leavePage" />
          </button>
          <button className="utts-cancel-button gift-cancel-order-cancel" onClick={() => null}>
            <Text t="giveUp" />
          </button>
        </div>
      ),
      className: 'warningModal-utts not-show-warning-buttons',
      okButtonProps: 'not-show-warning-buttons',
      onOk: async () => { },
      onCancel: async () => { },
    });
  };

  const clickExistUsers = async () => {
    showWarningDialog(1);
  };

  const handleAdd = async (addFlag = false) => {
    if (addFlag) {
      runChangeType2();
    } else {
      showWarningDialog(2);
    }
  };

  const tableRowUpdate = useCallback(
    (response, typeFlag = false) => {
      const row = { ...response?.data };
      const newData = [...cardList];
      const index = newData.findIndex((recordItem) => row.id === recordItem.id);
      const item = newData[index];
      newData.splice(index, 1, { ...item, ...row });
      setEditingKey(undefined);
      if (!typeFlag) {
        successDialog({
          title: <Text t="successfullySent" />,
          message: recordAddedSuccessfully,
        });
      }
      setShowError(false);
      if (!flagExistUsers) {
        const newNewData = newData?.filter((item) => item.cardOrderId);
        dispatch(setCardList([...newNewData, {}]));
        form.resetFields();
        if (currentCardOrder.cardType === 0) {
          setGsmRequired(false);
          setIsCheckedMobile(false);
          setMobilePaymentAuthorization(false);
        }
      }
    },
    [cardList, dispatch, form],
  );

  const getGsmErrorFields = (error) => {
    return error?.errorFields?.filter((item) => item.name[0] === 'gsm');
  };

  const checkIsMobile = useCallback(async () => {
    let isMobileChecked = false;
    const fieldsValues = await form.getFieldsValue();
    try {
      await form.validateFields();
      setShowError(false);
      form.setFieldsValue({ ...fieldsValues, mobilePaymentAuthorization: fieldsValues.gsm !== '' });
      if (fieldsValues.gsm !== '' && currentCardOrder.cardType === 0 && !isCheckedMobile) {
        setIsCheckedMobile(true);
        setGsmRequired(true);
      }
    } catch (error) {
      console.error(error);
      try {
        if (fieldsValues.gsm !== '' && currentCardOrder.cardType === 0 && !isCheckedMobile) {
          setIsCheckedMobile(true);
          setGsmRequired(true);
        }
      } catch (errorx) {
        console.error(errorx);
      }
      const gsmErrorMessage = getGsmErrorFields(error);
      isMobileChecked = gsmErrorMessage.length > 0;
      setShowError(isMobileChecked);
      form.setFieldsValue({
        ...fieldsValues,
        mobilePaymentAuthorization: fieldsValues.gsm
          ? currentCardOrder.cardType === 0
            ? true
            : !isMobileChecked
          : isMobileChecked,
      });
    }
  }, [form]);

  const checkIsMobile2 = useCallback(async () => {
    let isMobileChecked = false;
    const fieldsValues = await form.getFieldsValue();
    try {
      for (const [key, value] of Object.entries(fieldsValues)) {
        try {
          const ref = key.split('gsm-')[1];
          const tempRecord = cardList?.find((cL) => cL.refNo === ref);
          if (tempRecord) {
            const rec = { ...tempRecord, gsm: value };
            await handleUpdate2(rec);
          }
        } catch (err) {
          console.error(err);
        }
      }
    } catch (error) {
      console.error(error);
      const gsmErrorMessage = getGsmErrorFields(error);
      isMobileChecked = gsmErrorMessage.length > 0;
      form.setFieldsValue({
        ...fieldsValues,
        mobilePaymentAuthorization: fieldsValues.gsm ? !isMobileChecked : isMobileChecked,
      });
    }
  }, [form, cardList, currentCardOrder, addedFromExistList, mobilePaymentAuthorization]);
  const currentCardOrderRef = useRef(currentCardOrder);
  useEffect(() => {
    currentCardOrderRef.current = currentCardOrder;
  }, [currentCardOrder]);

  const changeAmount = useCallback(async () => {
    let isMobileChecked = false;
    const fieldsValues = await form.getFieldsValue();
    try {
      let tempNewaddedFromExistList = addedFromExistList;
      for (const [key, value] of Object.entries(fieldsValues)) {
        try {
          const ref = key?.split('price-')[1];
          const tempRecord = cardList?.filter((cL) => cL.refNo === ref)[0];
          const existPriceCheck = addedFromExistList?.filter((aFEL) => aFEL.refNo === ref);
          if (tempRecord && !(existPriceCheck.length > 0 && existPriceCheck[0].price === value)) {
            const rec = { ...tempRecord, price: value };
            let arr = [];
            cardList?.map((item) => {
              if (item.id === rec.id) {
                arr.push(rec);
              } else {
                arr.push(item);
              }
            });
            tempNewaddedFromExistList = await handleUpdate2(rec, tempNewaddedFromExistList);
            dispatch(setCardList([...arr]));
          }
        } catch (err) {
          console.error(err);
        }
      }
    } catch (error) {
      console.error(error);
      const gsmErrorMessage = getGsmErrorFields(error);
      isMobileChecked = gsmErrorMessage.length > 0;
      form.setFieldsValue({
        ...fieldsValues,
        mobilePaymentAuthorization: fieldsValues.gsm ? !isMobileChecked : isMobileChecked,
      });
    }
  }, [form, cardList, currentCardOrder, addedFromExistList, mobilePaymentAuthorization]);

  const validateFormFields = async (form, record) => {
    try {
      let values = await form.validateFields();
      if (record?.addressText && !values.addressText) {
        values.addressText = record.addressText;
      }
      return values;
    } catch (error) {
      console.log('error', error);
      const gsmErrorMessage = getGsmErrorFields(error);
      setShowError(gsmErrorMessage.length > 0);
      return false;
    }
  };

  const handleSaveError = (message) => {
    errorDialog({
      title: <Text t="error" />,
      message,
    });
  };

  const saveDetail = useCallback(
    async (record) => {
      try {
        const values = await validateFormFields(form, record);
        if (!values) return;
        if (
          isGreaterMaximumLoadedAmount({
            controlValue: maximumLoadedAmount,
            price: values.price,
          })
        ) {
          handleSaveError(maximumLoadingLimitPerCardIs.replaceAll('{amount}', maximumLoadedAmount));

          return;
        }
        const body = {
          ...values,
          refNo: values?.refNo ? values?.refNo : null,
          vouId,
          addressId: values?.addressId || form.getFieldValue('addressId') || record?.addressId,
          email: values?.email || form.getFieldValue('email') || record?.email || null,
          gsm: !values?.gsm
            ? null
            : values?.gsm
              ?.replace(/\)/g, '')
              ?.replace(/\(/g, '')
              ?.replace(/-/g, '')
              ?.replace(/ /g, ''),
          mobilePaymentAuthorization: currentCardOrder?.cardType
            ? true
            : mobilePaymentAuthorization,
        };

        if (!body.addressId) {
          const getFieldsValue = await form.getFieldsValue();
          if (!getFieldsValue.addressId) {
            await dispatch(setLoadingState(false));
            handleSaveError(`Lütfen adres giriniz.`);
            return;
          }
        }
        if (gsmCheckForBody(body)) {
          await dispatch(setLoadingState(false));
          handleSaveError(`Lütfen GSM numarası giriniz.`);
          return;
        }
        if (contactInfoCheckForBody(body)) {
          await dispatch(setLoadingState(false));
          handleSaveError(digitalCardContactInfoRequired);
          return;
        }
        if (nameSurnameCheckForBody(body) && currentCardOrder?.printNameSurname) {
          await dispatch(setLoadingState(false));
          handleSaveError(`Lütfen isim ve soyisim giriniz.`);
          return;
        }
        const action = await dispatch(cardOrderDetailSave(body));
        if (cardOrderDetailSave.fulfilled.match(action)) {
          const refNo = action?.payload?.data?.refNo || null;

          if (action?.payload?.data?.errorMessage) {
            confirmDialog({
              title: <Text t="attention" />,
              message: action?.payload?.data?.errorMessage,
              cancelText: "Kart İşlemleri'ne Git",
              okText: 'Devam Et',
              onOk: async () => {
                const result = await dispatch(cardOrderDetailSave({ isContinue: true, ...body }));
                tableRowUpdate({
                  ...result?.payload,
                  data: { ...result?.payload?.data, addressText: record?.addressText, refNo },
                });
              },
              onCancel: async (closeByIconOrEsc) => {
                if (!closeByIconOrEsc) {
                  history.push({
                    pathname: '/ticket-gift/manage-my-cards',
                  });
                }
              },
              maskClosable: true,
            });
          } else {
            tableRowUpdate({
              ...action?.payload,
              data: { ...action?.payload?.data, addressText: record?.addressText, refNo },
            });
          }
        }

        if (cardOrderDetailSave.rejected.match(action)) {
          if (action?.payload?.data?.length > 0) {
            handleSaveError(action?.payload?.data?.join('\n'));
          } else {
            handleSaveError(action?.payload?.error?.message);
          }
        }
      } catch (error) { }
    },
    [dispatch, form, tableRowUpdate, mobilePaymentAuthorization],
  );

  const handleSave = useCallback(async () => {
    if (editingKey) {
      const uL = cardList?.filter((cL) => cL.id === editingKey);
      if (uL?.length > 0) {
        handleUpdate(uL[0], true);
      }
      return;
    }
    await dispatch(setLoadingState(true));
    let fieldsValues = await form.getFieldsValue();
    if (cardList[cardList.length - 1].addressText) {
      fieldsValues.addressText = cardList[cardList.length - 1].addressText;
    }
    if (isLoading) return;
    setIsLoading(true);

    try {
      const { id, cardOrderDetails, ...cardOrderBody } = currentCardOrder;
      if (id === 0) {
        const action = await dispatch(cardOrdersSave(cardOrderBody));
        if (cardOrdersSave.fulfilled.match(action)) {
          await saveDetail(fieldsValues);
        }
      } else {
        await saveDetail(fieldsValues);
      }
    } catch (e) {
      console.error('Error in handleSave:', e);
    } finally {
      setIsLoading(false);
      await dispatch(setLoadingState(false));
    }
  }, [currentCardOrder, dispatch, saveDetail, isLoading, editingKey]);

  const cleanGsm = (gsm) => {
    if (!gsm) return null;
    const cleaned = gsm.replace(/\)/g, '').replace(/\(/g, '').replace(/-/g, '').replace(/ /g, '');
    return cleaned.includes('+90') ? cleaned : '+90' + cleaned;
  };

  const handleUpdate = useCallback(
    async (record, isExpand = false) => {
      if (isLoading) return;
      setIsLoading(true);
      await dispatch(setLoadingState(true));
      try {
        const values = await form.validateFields();
        if (
          isGreaterMaximumLoadedAmount({
            controlValue: maximumLoadedAmount,
            price: values.price,
          })
        ) {
          handleSaveError(
            maximumLoadingLimitPerCardIs.replaceAll('{amount}', maximumLoadedAmount),
          );
          setIsLoading(false);
          await dispatch(setLoadingState(false));
          return;
        }

        const bodyMobilePaymentAuthorization =
          currentCardOrder?.cardType || uploadedExcel ? true : mobilePaymentAuthorization;
        const body = flagExistUsers
          ? {
            ...record,
            vouId,
            mobilePaymentAuthorization: bodyMobilePaymentAuthorization,
            gsm: cleanGsm(record.gsm),
            email: record.email || null,
          }
          : {
            id: record?.id,
            ...values,
            refNo: values?.refNo ? values?.refNo : null,
            vouId,
            mobilePaymentAuthorization: bodyMobilePaymentAuthorization,
            gsm: cleanGsm(values?.gsm),
            email: values?.email || null,
          };

        if (gsmCheckForBody(body)) {
          await dispatch(setLoadingState(false));
          handleSaveError(`Lütfen GSM numarası giriniz.`);
          return;
        }
        if (contactInfoCheckForBody(body)) {
          await dispatch(setLoadingState(false));
          handleSaveError(digitalCardContactInfoRequired);
          return;
        }
        const action = await dispatch(cardOrderDetailUpdate(body));
        if (cardOrderDetailUpdate.fulfilled.match(action)) {
          const refNo = action?.payload?.data?.refNo || null;
          tableRowUpdate({
            ...action?.payload,
            data: {
              ...action?.payload?.data,
              addressText: record?.addressText,
              refNo,
              gsm: body?.gsm,
            },
          });
          if (isExpand) setEditingRowKeys(null);
        } else if (cardOrderDetailUpdate.rejected.match(action)) {
          const errorMessage =
            action?.payload?.data?.length > 0
              ? action.payload.data.join('\n')
              : action?.payload?.error?.message;

          handleSaveError(errorMessage);
        }
        await dispatch(setLoadingState(false));
      } catch (error) {
        console.error('Error in handleUpdate:', error);
        const gsmErrorMessage = getGsmErrorFields(error);
        setShowError(gsmErrorMessage.length > 0);
        await dispatch(setLoadingState(false));
      } finally {
        setIsLoading(false);
        await dispatch(setLoadingState(false));
      }
    },
    [
      dispatch,
      form,
      maximumLoadedAmount,
      tableRowUpdate,
      isLoading,
      uploadedExcel,
      mobilePaymentAuthorization,
    ],
  );

  const getGsmValue = (record, values) => {
    if (record.gsm) return cleanGsm(record.gsm);
    const key = `gsm-${record?.refNo?.toString()}`;
    return values[key] ? cleanGsm(values[key]) : null;
  };

  const getEmailValue = (record, values) => {
    const key = `email-${record?.refNo?.toString()}`;
    if (values[key] !== undefined) return values[key] || null;
    if (values.email !== undefined) return values.email || null;
    return record.email || null;
  };

  const getMobileCheckValue = (record, values) => {
    const key = `mobilePaymentAuthorization-${record?.refNo?.toString()}`;
    return values[key] ?? false;
  };

  const gsmCheckForBody = (body) => {
    if (body.mobilePaymentAuthorization && !body.gsm && !currentCardOrderCardTypeDigital) {
      return true;
    }
  };

  const contactInfoCheckForBody = (body) => {
    if (enableDigitalContactInfo && currentCardOrderCardTypeDigital && !body.gsm && !body.email) {
      return true;
    }
  };

  const nameSurnameCheckForBody = (body) => {
    if (!body.mobilePaymentAuthorization && (!body.name || !body.surname)) {
      return true;
    }
  };

  const checkAction = (action) => {
    return (
      (action?.type === 'cardOrderDetailSave/fulfilled' ||
        action?.type === 'cardOrderDetailUpdate/fulfilled') &&
      action?.payload?.isSuccess &&
      !action?.payload?.error?.message &&
      !(action?.payload?.data?.errorMessage?.length > 0)
    );
  };

  const handleUpdate2 = async (record, tempAddedFromExistList = []) => {
    setIsLoading(true);
    await dispatch(setLoadingState(true));
    let newaddedFromExistList =
      tempAddedFromExistList?.length > 0
        ? tempAddedFromExistList
        : addedFromExistList?.map((afel) => afel);
    try {
      const values = await form.getFieldsValue();
      if (
        isGreaterMaximumLoadedAmount({
          controlValue: maximumLoadedAmount,
          price: values.price ?? values['price-' + record?.refNo?.toString()],
        })
      ) {
        handleSaveError(
          maximumLoadingLimitPerCardIs.replaceAll('{amount}', maximumLoadedAmount),
        );
        setIsLoading(false);
        await dispatch(setLoadingState(false));
        return;
      }
      const latestCurrentCardOrder = currentCardOrderRef.current;
      const { id, cardOrderDetails, ...cardOrderBody } = latestCurrentCardOrder;
      let tempCardOrderId = record.cardOrderId;
      if (id === 0) {
        const action = await dispatch(cardOrdersSave(cardOrderBody));
        if (action?.payload?.data?.id) tempCardOrderId = action?.payload?.data?.id;
      }
      const gsmValue = getGsmValue(record, values);
      const getMobileValue = getMobileCheckValue(record, values);

      let tempCustomerId = record.customerId ?? selectedCustomer?.customerId;

      let body = {
        vouId,
        mobilePaymentAuthorization:
          currentCardOrderCardTypeDigital || uploadedExcel
            ? true
            : flagExistUsers
              ? getMobileValue
              : mobilePaymentAuthorization,
        gsm: gsmValue,
        email: getEmailValue(record, values),
        refNo: record.refNo,
        addressId:
          record.addressId ||
          values?.addressId ||
          form.getFieldValue('addressId') ||
          record.addressValue,
        cardOrderId: tempCardOrderId,
        customerId: tempCustomerId,
        name: record.name,
        surname: record.surname,
        price: record.price,
      };
      if (gsmCheckForBody(body)) {
        await dispatch(setLoadingState(false));
        handleSaveError(`Lütfen GSM numarası giriniz.`);
        return;
      }
      if (contactInfoCheckForBody(body)) {
        await dispatch(setLoadingState(false));
        handleSaveError(digitalCardContactInfoRequired);
        return;
      }
      const flagIfAdded = newaddedFromExistList?.filter((aFEL) => aFEL.refNo === record.refNo);

      if (flagIfAdded?.length > 0) {
        body.id = flagIfAdded[0].id;
      }
      const action =
        flagIfAdded?.length > 0
          ? await dispatch(cardOrderDetailUpdate(body))
          : await dispatch(cardOrderDetailSave(body));

      if (checkAction(action)) {
        const refNo = action?.payload?.data?.refNo || null;
        tableRowUpdate(
          {
            ...action?.payload,
            data: {
              ...action?.payload?.data,
              addressText: record?.addressText,
              refNo,
              gsm: body?.gsm,
            },
          },
          action?.type === 'cardOrderDetailUpdate/fulfilled',
        );
        if (!flagIfAdded?.length > 0) {
          newaddedFromExistList.push(action?.payload?.data);
          setAddedFromExistList(newaddedFromExistList);
        }
      } else {
        if (action?.payload?.data?.errorMessage?.length > 0) {
          confirmDialog({
            title: <Text t="attention" />,
            message: action?.payload?.data?.errorMessage,
            cancelText: "Kart İşlemleri'ne Git",
            okText: 'Devam Et',
            onOk: async () => {
              const result = await dispatch(cardOrderDetailSave({ isContinue: true, ...body }));

              const refNo = result?.payload?.data?.refNo || null;
              tableRowUpdate({
                ...result?.payload,
                data: {
                  ...result?.payload?.data,
                  addressText: record?.addressText,
                  refNo,
                  gsm: body?.gsm,
                },
              });
              if (!flagIfAdded?.length > 0) {
                newaddedFromExistList.push(result?.payload?.data);
                setAddedFromExistList(newaddedFromExistList);
              }
            },
            onCancel: async (closeByIconOrEsc) => {
              if (!closeByIconOrEsc) {
                history.push({
                  pathname: '/ticket-gift/manage-my-cards',
                });
              }
            },
            maskClosable: true,
          });
        } else {
          const errorMessage =
            action?.payload?.data?.length > 0
              ? action.payload.data.join('\n')
              : action?.payload?.error?.message;

          handleSaveError(errorMessage);
        }
      }

      await dispatch(setLoadingState(false));
    } catch (error) {
      console.error('Error in handleUpdate:', error);
      await dispatch(setLoadingState(false));
    } finally {
      setIsLoading(false);
      await dispatch(setLoadingState(false));
    }
    return newaddedFromExistList;
  };

  const handleDelete = useCallback(
    (record, deleteItemIndex) => {
      confirmDialog({
        title: <Text t="attention" />,
        message: `${deleteItemIndex} numaralı kart bilgisini silmek istediğinizden emin misiniz?`,
        okText: <Text t="delete" />,
        cancelText: <Text t="giveUp" />,
        cancekButtonClass: 'dialog-cancel-transparent-button',
        okButtonClass: 'dialog-ok-red-button',
        onOk: async () => {
          const action = await dispatch(cardOrderDetailDelete({ id: record?.id }));
          if (cardOrderDetailDelete.fulfilled.match(action)) {
            const newCardList = cardList.filter((item) => item?.id !== record?.id);
            successDialog({
              title: <Text t="successfullySent" />,
              message: action?.payload?.message || yourTransactionHasBeenSuccessfullyCompleted,
              onOk: () => {
                dispatch(setCardList(newCardList));
              },
            });
          }
        },
      });
    },
    [cardList, dispatch],
  );

  const handleEdit = useCallback(
    async (record) => {
      setEditingRowKeys((expandedRows) => {
        if (expandedRows?.includes(`card-order-${record?.id || record?.addressId}`)) {
          return expandedRows.filter(
            (id) => id !== `card-order-${record?.id || record?.addressId}`,
          );
        }
        return [`card-order-${record?.id || record?.addressId}`];
      });
      const newData = cardList?.filter((item) => item.cardOrderId);
      await dispatch(setCardList([...newData]));
      if (record?.id) {
        form.setFieldsValue({
          ...record,
        });
        setEditingKey(record?.id);
        return;
      }
      setEditingKey(record?.id);
      form.resetFields();
    },
    [form, editingKey, cardList],
  );

  const handleSaveGiveUp = useCallback(() => {
    const newCardList = cardList?.filter((item) => item?.id !== undefined);
    setEditingKey('');
    form.resetFields();
    dispatch(setCardList(newCardList));
    setShowNewCardButtons(false);
    setEditingRowKeys(null);
  }, [cardList, dispatch, form]);

  const handleTableChange = useCallback(
    async (pageNumber, pageSize) => {
      await dispatch(cardOrderDetailsGelAll({ pageNumber, pageSize }));
    },
    [dispatch],
  );

  const handleTableFlagExistChange = useCallback(
    async (pageNumber, pageSize) => {
      await dispatch(setLoadingState(true));
      await dispatch(
        getCurrentEmployeeList({
          loadBalanceId: currentLoadBalance?.id,
          showOnlyPriced: false,
          vouId,
          pageNumber,
          pageSize: 100000,
        }),
      );
      await dispatch(setLoadingState(false));
    },
    [currentLoadBalance?.id, dispatch, vouId],
  );

  const handleAddressChoose = useCallback(
    (record) => {
      dispatch(setSelectedRow({ ...record }));
      setIsModalDeliveryAddressChoose(true);
    },
    [dispatch],
  );

  const handleAddressAdd = useCallback(
    (record) => {
      dispatch(setSelectedRow({ ...record }));
      setIsModalDeliveryAddressAdd(true);
    },
    [dispatch],
  );

  const handleSelectedAddress = useCallback(
    async (selectedValues) => {
      if (selectedValues.addressText === '') return;
      const row = {
        ...selectedRow,
        addressId: selectedValues?.addressValue,
        addressText: selectedValues?.addressText,
      };
      form.setFieldsValue({
        ...row,
      });
      const newData = [...cardList];
      const recordIndex = newData.findIndex((recordItem) => row.id === recordItem.id);
      const newItem = newData[recordIndex];
      newData.splice(recordIndex, 1, { ...newItem, ...row });
      dispatch(setCardList(newData));
      if (selectedValues?.allCardAddressChecked !== undefined) {
        setIsModalDeliveryAddressChoose(false);
      } else {
        setIsModalDeliveryAddressAdd(false);
      }
    },
    [cardList, dispatch, form, selectedRow],
  );

  useEffect(() => {
    (async () => {
      if (addressListByUserQuery.length === 0) {
        await dispatch(
          addressGetPagedListByUserQuery({
            pageNumber: 0,
            pageSize: 0,
          }),
        );
      }
    })();
  }, []);

  useEffect(async () => {
    setGsmRequired(currentCardOrder?.cardType === 0);
    setCurrentCardOrderCardTypeDigital(currentCardOrder?.cardType !== 0);
    setIsCheckedMobile(currentCardOrder?.cardType !== 0);
    setMobilePaymentAuthorization(currentCardOrder?.cardType !== 0);
    await clickCheck({ target: { checked: currentCardOrder?.cardType !== 0 } });
  }, [currentCardOrder?.cardType]);

  const editableActionButtons = (record) => {
    return (
      <div className="card-order-action-buttons">
        <Button
          id="cardOrders-cardInformation-cardDetailInformation-editable-row-save-btn"
          onClick={() => handleUpdate(record)}
          className="compliment-editable-row-save-btn"
          disabled={isLoading}
        >
          <CustomImage src={edit} />
        </Button>

        <Button
          id="cardOrders-cardInformation-cardDetailInformation-table-row-delete-btn"
          onClick={handleSaveGiveUp}
          className={'table-row-delete-btn'}
        >
          <CustomImage src={trash} />
        </Button>
      </div>
    );
  };

  const deliveryAddressClickHandler = useCallback((record) => {
    return handleAddressChoose(record);
  }, []);

  const editableAddressRender = (deliveryAddress, record) => {
    return deliveryAddress ? (
      <button
        className="table-cell-address-choose"
        style={{ borderWidth: 0, backgroundColor: 'transparent' }}
        onClick={() => deliveryAddressClickHandler(record)}
      >
        {deliveryAddress}
      </button>
    ) : (
      <>
        <button
          className="table-cell-address-choose"
          style={{ borderWidth: 0, backgroundColor: 'transparent' }}
          onClick={() => handleAddressChoose(record)}
        >
          <Text t="selectAddress2" />
        </button>
        <span className="table-cell-address-or"> <Text t="or" /> </span>
        <button
          className="table-cell-address-add"
          style={{ borderWidth: 0, backgroundColor: 'transparent' }}
          onClick={() => handleAddressAdd(record)}
        >
          <Text t="addNew2" />
        </button>
      </>
    );
  };

  const handleDownloadExcel = useCallback(async () => {
    try {
      const data = await cardOrderDetailsServices.getCardOrderDetailExcelTemplate({
        PrintNameSurname: requiredName,
        customerId: selectedCustomer?.customerId,
        cardType: currentCardOrder?.cardType,
        vouId: vouId,
      });
      download(
        data,
        `${getFileNameByLanguage('yeni-kart-ekle', 'add-new-card')}-${dayjs().format('DD-MM-YYYY hh:mm')}.xlsx`,
      );
    } catch (error) {
      handleSaveError(error?.statusText);
    }
  }, [
    selectedCustomer?.customerId,
    currentCardOrder?.cardType,
    currentCardOrder?.printNameSurname,
    requiredName,
  ]);

  const clickCheck = async (e) => {
    const val = e?.target?.checked;
    const fieldsValues = await form.getFieldsValue();
    setMobilePaymentAuthorization(val);
    form.setFieldsValue({ ...fieldsValues, mobilePaymentAuthorization: val });
    if (!!val && currentCardOrder?.cardType === 0) {
      setGsmRequired(true);
    } else {
      setGsmRequired(false);
    }
  };

  const getTitleWithAsterisk = (label, isRequired) =>
    isRequired ? (
      <>
        {label} <span className="table-header-validation"> *</span>
      </>
    ) : (
      label
    );

  const checkRecordWithSelectedItems = (record) => {
    return (
      selectedItems?.filter((sI) => parseInt(sI.split('card-order-')[1], 10) === record.id)
        ?.length > 0
    );
  };

  const gsmColumn = {
    title: currentCardOrderCardTypeDigital && enableDigitalContactInfo
      ? gsmNoUpperCase
      : getTitleWithAsterisk(gsmNoUpperCase, requiredColumn),
    dataIndex: 'gsm',
    key: 'gsm',
    width: 170,
    align: 'center',
    onCell: (record) => ({
      record,
      input: flagExistUsers
        ? getInput2(checkIsMobile2)
        : getInput2(checkIsMobile, showError && !currentCardOrderCardTypeDigital),
      rules: (fields, value) => {
        if (
          (!!value && value !== '+90 (___) ___ __ __') ||
          (requiredColumn && !currentCardOrderCardTypeDigital)
        ) {
          return formPhoneRegex(fields, value);
        }
        return Promise.resolve();
      },
      dataIndex: !flagExistUsers ? 'gsm' : 'gsm' + '-' + record.refNo,
      editing: flagExistUsers ? checkRecordWithSelectedItems(record) : isEditing(record),
      required: requiredColumn && !currentCardOrderCardTypeDigital,
    }),
  };

  const emailColumn = {
    title: emailUpperCase,
    dataIndex: 'email',
    key: 'email',
    width: 170,
    align: 'center',
    onCell: (record) => ({
      record,
      input: getInput7(),
      rules: async (fields, value) => {
        if (!value) return Promise.resolve();
        return formMailRegex(fields, value);
      },
      dataIndex: !flagExistUsers ? 'email' : 'email-' + record.refNo,
      editing: flagExistUsers ? checkRecordWithSelectedItems(record) : isEditing(record),
      required: false,
    }),
  };

  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      align: 'center',
      width: 70,
      render: (_, __, index) =>
        (flagExistUsers
          ? tablePropertyEmployeeList?.currentPage - 1
          : tableProperty?.currentPage - 1) *
        (flagExistUsers ? tablePropertyEmployeeList?.pageSize : tableProperty?.pageSize) +
        index +
        1,
    },
    {
      title: getTitleWithAsterisk(nameUpperCase, requiredName),
      dataIndex: 'name',
      key: 'name',
      width: 150,
      onCell: (record) => ({
        record,
        input: getInput(openModalWarning),
        dataIndex: 'name',
        editing: isEditing(record),
        required: requiredName,
      }),
    },
    {
      title: getTitleWithAsterisk(surnameUpperCase, requiredName),
      dataIndex: 'surname',
      key: 'surname',
      width: 150,
      onCell: (record) => ({
        record,
        input: getInput1(),
        dataIndex: 'surname',
        editing: isEditing(record),
        required: requiredName,
      }),
    },
    currentCardOrderCardTypeDigital && enableDigitalContactInfo
      ? {
        title: (
          <span className="communication-info-header">
            <span className="communication-info-label">
              <Text t="communicationInfoUpperCase" />
              <span className="table-header-validation">*</span>
            </span>
            <Tooltip
              title={digitalCardContactInfoRequired}
              trigger="click"
              overlayInnerStyle={{ padding: '12px 16px' }}
            >
              <CustomImage src={iconInfo} />
            </Tooltip>
          </span>
        ),
        children: [gsmColumn, emailColumn],
      }
      : gsmColumn,
    {
      title: (
        <span className="reference-number-header">
          <span className="reference-number-label">
            <Text t="referenceNumber2" />
          </span>
          <Tooltip title={useText('thisIsTheNumberYouCanUseTo')}>
            <CustomImage src={iconInfo} />
          </Tooltip>
        </span>
      ),
      dataIndex: 'refNo',
      key: 'refNo',
      width: 180,
      align: 'center',
      onCell: (record) => ({
        record,
        input: getInput5(),
        dataIndex: 'refNo',
        editing: isEditing(record),
        required: false,
      }),
    },
  ];

  if (flagExistUsers) {
    columns.push({
      title: (
        <span>
          <Text t="mobilePayment" />
        </span>
      ),
      dataIndex: 'mobilePaymentAuthorization',
      key: 'mobilePaymentAuthorization',
      width: 180,
      align: 'center',
      onCell: (record) => ({
        record,
        input: () => {
          return (
            <Form.Item name={'mobilePaymentAuthorization-' + record.refNo} valuePropName="checked">
              <CustomCheckbox
                className="compliment-custom-checbox"
                onChange={async (e) => {
                  if (currentCardOrder?.cardType === 0) {
                    let row = {};
                    row['mobilePaymentAuthorization' + '-' + record.refNo] = e.target.checked;
                    await form.setFieldsValue({
                      ...row,
                    });
                  }
                }}
              />
            </Form.Item>
          );
        },
        dataIndex: 'mobilePaymentAuthorization' + '-' + record.refNo,
        editing: currentCardOrder?.cardType === 0 && checkRecordWithSelectedItems(record),
        required: false,
      }),
      render: (_, record) => {
        return (
          <CustomImage
            src={
              currentCardOrder?.cardType !== 0 || record.mobilePaymentAuthorization
                ? compTick
                : compMinus
            }
          />
        );
      },
    });
  }

  columns.push({
    title: (
      <>
        {flagExistUsers || currentCardOrderCardTypeDigital ? <Text t="address" /> : <Text t="deliveryAddress" />}{' '}
        <span className={'table-header-validation'}>*</span>
      </>
    ),
    dataIndex: 'addressId',
    key: 'addressId',
    width: 132.7,
    align: 'center',
    onCell: (record) => ({
      record,
      input: getInput6(editableAddressRender, record),
      dataIndex: 'addressId',
      editing: isEditing(record),
      required: !record?.addressId,
    }),
    render: (_, record) => {
      return record?.addressText ?? <Text t="noAddress" />;
    },
  });
  columns.push({
    title: <Text t="price" />,
    dataIndex: 'price',
    key: 'price',
    width: 120,
    align: 'center',
    onCell: (record) => ({
      record,
      input: flagExistUsers ? getInput4(changeAmount, amount3) : getInput4(null, amount3),
      dataIndex: !flagExistUsers ? 'price' : 'price' + '-' + record.refNo,
      editing: flagExistUsers ? checkRecordWithSelectedItems(record) : isEditing(record),
      required: false,
    }),
    render: (text) => <span>{text ? `${moneyFormat(text, false)}` : '0'}</span>,
  });
  columns.push({
    title: '',
    dataIndex: 'action',
    key: 'action',
    width: flagExistUsers ? 0 : 110,
    align: 'center',
    render: (_, record, index) => {
      if (flagExistUsers || editingKey) return <div style={{ height: 30 }} />;
      const editable = isEditing(record);
      if (record.id) {
        return editable ? (
          editableActionButtons(record)
        ) : (
          <div className="card-order-action-buttons">
            <Button
              id="cardOrders-cardInformation-cardDetailInformation-table-row-edit-btn"
              className="compliment-editable-row-save-btn"
              onClick={() => handleEdit(record)}
            >
              <CustomImage src={edit} />
            </Button>

            <Button
              id="cardOrders-cardInformation-cardDetailInformation-second-table-row-delete-btn"
              className={'table-row-delete-btn'}
              onClick={() =>
                handleDelete(
                  record,
                  (flagExistUsers
                    ? tablePropertyEmployeeList?.currentPage - 1
                    : tableProperty?.currentPage - 1) *
                  (flagExistUsers
                    ? tablePropertyEmployeeList?.pageSize
                    : tableProperty?.pageSize) +
                  index +
                  1,
                )
              }
            >
              <CustomImage src={trash} />
            </Button>
          </div>
        );
      }
      return null;
    },
  });

  const openModalWarning = async () => {
    if (
      modalVisibled === false &&
      currentCardOrder?.cardType === 0 &&
      currentCardOrder?.printNameSurname === false
    ) {
      warningDialog({
        title: <Text t="attention" />,
        htmlContent: (
          <Text
            t={`<div>
                     Kart basım seçeneklerinde yer alan <b>Ad ve Soyad basılsın</b> seçeneğini
                    seçmediğiniz durumda bu bilgileri girseniz dahi kartların üzerine basılmayacaktır.
                  </div>`}
          />
        ),
        onOk: () => {
          setModalVisibled(true);
        },
      });
    }
  };

  const handleChange = (e) => {
    try {
      const value = e.target.value;
      if (value === '' || value === 0 || value === '0') setExistUserAllPrice('');
      if (!/^\d+([.,]\d{0,2})?$/.test(value)) return;
      if (parseInt(value, 10) < 1000000) setExistUserAllPrice(value);
    } catch (error) {
      console.error(error);
    }
  };

  const changeSelectionExistUsers = useCallback(
    async (record, data) => {
      try {
        if (record?.length === 0 && currentCardOrder.id && currentCardOrder.totalCount) {
          const tempCardType = currentCardOrder.cardType;
          const action = await dispatch(cardOrdersDelete());
          if (cardOrdersDelete.fulfilled.match(action)) {
            await dispatch(resetDetail());
            await dispatch(getCurrentCardOrder({ vouId }));
            await dispatch(setCurrentCardOrder({ cardType: tempCardType }));
          }
        }
        await dispatch(setSelectedExistUsersRow(record));
        const rows = {};
        const currentForm = await form.getFieldsValue();
        record?.map((item) => {
          if (
            selectedItems?.length === 0 ||
            selectedItems?.filter((sI) => sI === item).length < 1
          ) {
            const itemId = parseInt(item.split('card-order-')[1], 10);
            const filter = data?.filter((d) => d.id === itemId);
            if (
              filter?.length > 0 &&
              (currentForm['gsm-' + filter[0].refNo] !== filter[0].gsm ||
                currentForm['price-' + filter[0].refNo] !== filter[0].price)
            ) {
              if (filter[0].gsm) rows['gsm-' + filter[0].refNo] = filter[0].gsm;
              rows['price-' + filter[0].refNo] = filter[0].price;
            }
          }
        });

        if (Object.keys(rows).length > 0) {
          form.setFieldsValue(rows);
        }
        setSelectedItems(record);
      } catch (error) {
        console.error(error);
      }
    },
    [form, selectedItems, currentCardOrder],
  );

  const setSelectedPrice = async () => {
    try {
      let newCardList = [];
      const rows = {};
      cardList?.forEach((item) => {
        let tempItem = { ...item };
        selectedItems?.forEach((newItem) => {
          const itemId = parseInt(newItem.split('card-order-')[1], 10);
          if (tempItem.id === itemId) {
            tempItem.price = parseInt(existUserAllPrice, 10);
            rows['price-' + tempItem.refNo] = tempItem.price;
          }
        });
        newCardList.push(tempItem);
      });

      if (Object.keys(rows).length > 0) {
        form.setFieldsValue(rows);
      }
      dispatch(setCardList([...newCardList]));
      changeAmount();
    } catch (error) {
      console.error(error);
    }
  };

  const setSelectedAllPrice = () => {
    try {
      const newCardList =
        cardList?.map((item) => ({
          ...item,
          price: parseInt(existUserAllPrice, 10),
        })) || [];

      setAllPageAmountChange(true);
      dispatch(setCardList(newCardList));
    } catch (error) {
      console.error(error);
    }
  };

  const setComplimentExcelUpload = async ({ data }) => {
    if (data) {
      await dispatch(setSelectedExistUsersRow([]));
      setFlagExistUsers(false);
      setUploadedExcel(true);
    }
  };

  const onMenuClick = (key) => {
    try {
      setShowPageCount(parseInt(key?.key.toString(), 10));
    } catch (error) {
      console.error(error);
    }
  };

  const menuPlate = () => (
    <Menu onClick={(key) => onMenuClick(key)} className="custom-dropdown-menu">
      <Menu.Item key="100" className="custom-dropdown-item">
        100
      </Menu.Item>
      <Menu.Item key="200" className="custom-dropdown-item">
        200
      </Menu.Item>
      <Menu.Item key="500" className="custom-dropdown-item">
        500
      </Menu.Item>
    </Menu>
  );

  function expandedRowRender(record) {
    return (
      <div className="compliment-table-footer">
        <CustomCheckbox
          checked={isCheckedMobile}
          defaultChecked={true}
          className="compliment-custom-checbox"
          onChange={(e) => {
            if (!currentCardOrderCardTypeDigital) {
              setIsCheckedMobile(e?.target?.checked);
              setMobilePaymentAuthorization(e?.target?.checked);
              setGsmRequired(e?.target?.checked);
              setRequiredColumn(e?.target?.checked);
              setShowError(false);
            }
          }}
        >
          <div className="checbox-text">
            <Text t="hasMobilePaymentPermission" />
          </div>
        </CustomCheckbox>
        <button onClick={handleSave} className="compliment-save-button">
          <Text t="cardParameterSave" />
        </button>
        <button onClick={handleSaveGiveUp} className="compliment-cancel-button">
          {editingKey ? <Text t="giveUp" /> : <Text t="clear" />}
        </button>
      </div>
    );
  }

  return (
    <div>
      <div style={{ display: 'flex', marginBottom: 20, flexDirection: 'row' }}>
        <div style={{ flex: 1 }}>
          <div className="compliment-card-information-header-tools" style={{ gap: 10 }}>
            <CustomButton
              id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-download-btn"
              className="download-btn"
              onClick={handleDownloadExcel}
            >
              <CustomImage src={downloadIcon} />
              <Text t="downloadExcelTemplate" />
            </CustomButton>
            <CustomButton
              id="ticketRestaurant-cardOrders-cardInformation-cardDetailInformation-upload-btn"
              className="upload-btn"
              onClick={() => setUploadModalVisible(true)}
            >
              <CustomImage src={uploadIcon} />
              <Text t="uploadWithExcel" />
              <CustomImage src={excelIcon} />
            </CustomButton>
          </div>
        </div>
        <div className="compliment-card-information-header-tools">
          {flagExistUsers ? (
            <>
              {showExistingUsersPickerButton && (
                <button className="div-add-new-name-btn" onClick={clickExistUsers}>
                  <p className="add-new-name-btn">
                    <Text t="selectFromExistingEmployeeList" />
                  </p>
                </button>
              )}
              <button className="div-exist-btn" onClick={() => handleAdd()}>
                <CustomImage src={addPassive} />
                <p className="exist-btn">
                  <Text t="addNewName" />
                </p>
              </button>
            </>
          ) : (
            <>
              {showExistingUsersPickerButton && showExistUserButton && (
                <button className="div-exist-btn" onClick={clickExistUsers}>
                  <p className="exist-btn">
                    <Text t="selectFromExistingEmployeeList" />
                  </p>
                </button>
              )}
              {vouId != VouIdCode.Market && (
                <button className="div-add-new-name-btn" onClick={() => handleAdd()}>
                  <CustomImage src={plusIcon} />
                  <p className="add-new-name-btn">
                    <Text t="addNewName" />
                  </p>
                </button>
              )}
            </>
          )}
        </div>
      </div>

      <CustomCollapseCard
        cardTitle={flagExistUsers ? currentEmployeeList : cardInformation2}
        cardTitleAlign="center"
        titleColor="#1d2228"
        titleSize="16px"
        showExpandIcon={false}
      >
        {flagExistUsers ? (
          <Form
            form={form}
            initialValues={currentCardOrderCardTypeDigital && { mobilePaymentAuthorization: true }}
            component={false}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 16,
                paddingTop: 10,
                paddingBottom: 10,
              }}
            >
              {currentCardOrderCardTypeDigital ? (
                <div className="compliment-exist-users-orange">
                  <Text t="gsmInformationIsRequiredForAllUsersTo" />
                </div>
              ) : null}

              <div className="complimenet-exist-users-gray">
                <span className="table-cell-address-or">
                  <Text t="pleaseEnterTheBalanceAmountYouWantTo" />
                </span>
                <div style={{ display: 'flex' }}>
                  <CustomInput
                    value={existUserAllPrice}
                    onChange={handleChange}
                    placeholder={amount3}
                    className="compliment-exist-users-input"
                  />
                  <div className="compliment-exist-users-inputbox">₺</div>
                </div>
                <button onClick={setSelectedPrice} className="compliment-exist-users-run-selected">
                  <Text t="applyToSelected" />
                </button>
                <button onClick={setSelectedAllPrice} className="compliment-exist-users-run-all">
                  <Text t="applyToAll" />
                </button>
              </div>
            </div>
            <CustomTable
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              rowSelection={{
                preserveSelectedRowKeys: true,
                type: 'checkbox',
                selectedItems,
                onChange: async (record, data) => {
                  changeSelectionExistUsers(record, data);
                },
                onSelectAll: async (selected) => {
                  console.log('selected', selected);
                },
              }}
              pagination={false}
              dataSource={cardList}
              columns={columns}
              className="compliment-card-information-table"
              rowKey={(record) => `card-order-${record?.id || record?.addressId}`}
            />
          </Form>
        ) : (
          <Form
            form={form}
            initialValues={currentCardOrderCardTypeDigital && { mobilePaymentAuthorization: true }}
            component={false}
          >
            <CustomTable
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              pagination={false}
              dataSource={cardList}
              columns={columns}
              className="compliment-card-information-table"
              rowKey={(record) => `card-order-${record?.id || record?.addressId}`}
              expandedRowKeys={editingRowKeys}
              expandable={{
                showExpandColumn: false,
                expandIconColumnIndex: 17,
                onExpand: (expanded, record, key) =>
                  editingRowKeys === key ? setEditingRowKeys(null) : setEditingRowKeys([key]),
                expandedRowRender: expandedRowRender,
              }}
            />
          </Form>
        )}
        {!editingKey && !uploadedExcel && !flagExistUsers && showNewCardButtons ? (
          <div className="compliment-table-footer">
            <CustomCheckbox
              checked={isCheckedMobile}
              defaultChecked={true}
              className="compliment-custom-checbox"
              onChange={(e) => {
                if (!currentCardOrderCardTypeDigital) {
                  setIsCheckedMobile(e?.target?.checked);
                  setGsmRequired(e?.target?.checked);
                  setRequiredColumn(e?.target?.checked);
                  setMobilePaymentAuthorization(e?.target?.checked);
                  setShowError(false);
                }
              }}
            >
              <div className="checbox-text">
                <Text t="hasMobilePaymentPermission" />
              </div>
            </CustomCheckbox>
            <button onClick={handleSave} className="compliment-save-button">
              <Text t="cardParameterSave" />
            </button>
            <button onClick={handleSaveGiveUp} className="compliment-cancel-button">
              {editingKey ? <Text t="giveUp" /> : <Text t="clear" />}
            </button>
          </div>
        ) : null}

        <div
          className="compliment-person-information-table-footer"
          style={{ marginTop: flagExistUsers ? 20 : 0 }}
        >
          <div className="d-flex">
            {/*flagExistUsers && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  position: 'absolute',
                  left: 20,
                  top: 30,
                  alignItems: 'center',
                }}
              >
                <span className="compliment-more-pagination-text">Gösterilecek Öğe:</span>

                <Dropdown overlay={menuPlate} trigger={['click']}>
                  <span className="compliment-inputbox">
                    {showPageCount}
                    <CustomImage style={{ marginLeft: 10 }} src={iconChevronDown} />
                  </span>
                </Dropdown>
              </div>
            )}
            {flagExistUsers ? (
              <CustomPagination
                current={tablePropertyEmployeeList?.currentPage}
                defaultCurrent={1}
                pageSize={tablePropertyEmployeeList?.pageSize}
                total={tablePropertyEmployeeList?.totalItems}
                onChange={async (pageNumber, pageSize) => {
                  await handleTableFlagExistChange(pageNumber, pageSize);
                }}
              />
            ) : (
              <CustomPagination
                current={tableProperty?.currentPage}
                defaultCurrent={1}
                pageSize={tableProperty?.pageSize}
                total={tableProperty?.totalCount}
                onChange={async (pageNumber, pageSize) => {
                  await handleTableChange(pageNumber, pageSize);
                }}
              />
            )*/}
            {!flagExistUsers ? (
              <CustomPagination
                current={tableProperty?.currentPage}
                defaultCurrent={1}
                pageSize={tableProperty?.pageSize}
                total={tableProperty?.totalCount}
                onChange={async (pageNumber, pageSize) => {
                  await handleTableChange(pageNumber, pageSize);
                }}
              />
            ) : null}
          </div>
          <div className="footer-info-container">
            <div className="footer-info-content">
              <CustomImage src={cardIcon} />
              <Text t="total" />{' '}
              <span style={{ marginLeft: 4, marginRight: 4 }}>{currentCardOrder?.totalCount}</span>{' '}
              <Text t="cardsAdded" />
            </div>
            <div className="total-amount-title">
              <Text t="totalBalanceToBeLoadedUpperCaseColon" />{' '}
              <span>{moneyFormat(currentCardOrder?.totalPrice, true)}</span>
            </div>
          </div>
        </div>
        <DeliveryAddressAddForm
          modalVisible={isModalDeliveryAddressAdd}
          handleModalVisible={setIsModalDeliveryAddressAdd}
          handleSelectedAddress={handleSelectedAddress}
        />
        <DeliveryAddressChooseForm
          modalVisible={isModalDeliveryAddressChoose}
          handleModalVisible={setIsModalDeliveryAddressChoose}
          handleAddFormModalVisible={setIsModalDeliveryAddressAdd}
          handleSelectedAddress={handleSelectedAddress}
        />
        <UploadFileModal
          modalVisible={uploadModalVisible}
          handleModalVisible={setUploadModalVisible}
          setComplimentExcelUpload={setComplimentExcelUpload}
          currentCardType={currentCardOrder?.cardType}
          {...uploadModalProps}
        />
      </CustomCollapseCard>
    </div>
  );
};
CardDetailInformation.propTypes = {
  form: PropTypes.any,
  resetCard: PropTypes.func,
  vouId: PropTypes.number,
  uploadModalProps: PropTypes.object,
  showExistingUsersPickerButton: PropTypes.bool,
  enableDigitalContactInfo: PropTypes.bool,
};

export default CardDetailInformation;
